import { Button, Modal } from "react-bootstrap";
import { SuccessSvg } from "assets/icons/SuccessSvg";
import { useNavigate, useLocation } from "react-router-dom";

function SuccessPopup({ message, value, show, handleClose }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigateToMySites = () => {
    handleClose();
    navigate("/sites");
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="md" centered>
        <Modal.Body className="d-flex justify-content-center align-items-center">
          <div className="d-flex flex-column align-items-center text-center">
            <SuccessSvg />
            <span className="mt-4 text-muted">
              <div className="text-start w-100">{message}</div>
              <span className="text-start fw-bold">{value}</span>
            </span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {location.pathname !== "/sites" && (
            <Button
              variant="outline-primary"
              onClick={() => handleNavigateToMySites()}
            >
              Go to My Sites
            </Button>
          )}
          <Button variant="primary" onClick={handleClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SuccessPopup;
